export default "__VITE_ASSET__0556a8c0__"